import React from "react";

// components
// import CreateTraining from "../misc/CreateTraining";
import Button from "../../../component/element/forms/Button";
import DataTable from "../../../component/element/table";
import ItemAction from "../../../component/ui/action/ItemAction";

// state
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  delete_training,
  get_trainings,
} from "../../../services/apis/training";
import { get_countries } from "../../../services/apis/locations";
import { ICountry } from "../../../store/types/locations";
import { ITraining } from "../../../store/types/training";
import { useNavigate } from "react-router-dom";
import { ColumnDef } from "@tanstack/react-table";
import { FaPlus } from "react-icons/fa6";

const Training = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { trainings, offset, limit, total, loadingTrainingId } = useAppSelector(
    ({ training }) => training,
  );
  const countries = useAppSelector(({ locations }) => locations.countries);
  const onLoad = React.useCallback(() => {
    get_trainings(dispatch, offset, limit);
  }, [dispatch, offset, limit]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  React.useEffect(() => {
    if (countries.length === 0) {
      get_countries(dispatch);
    }
  }, [countries.length, dispatch]);

  const getCountryName = (training: ITraining) => {
    const countryId = training.country?.id;
    if (countryId === undefined || countryId === null) return undefined;

    const country = countries.find(
      (item: ICountry) => String(item.id) === String(countryId),
    );
    return country?.name;
  };

  const columns: ColumnDef<ITraining>[] = [
    {
      accessorKey: "image",
      header: "Image",
      cell: ({ getValue }) => {
        const image = getValue() as string;
        return (
          <div className="w-full max-w-sm">
            <img
              loading="lazy"
              src={image}
              alt={image}
              className="w-11 h-auto object-cover rounded-lg"
            />
          </div>
        );
      },
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "amount",
      header: "Amount",
    },
    {
      accessorKey: "country",
      header: "Country",
      cell: ({ row }) => {
        const training = row.original;
        const countryName = getCountryName(training);

        return <span>{countryName || "N/A"}</span>;
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ row }) => {
        const data = row.original;
        const isDeleting = loadingTrainingId === data.id;
        return (
          <ItemAction
            delete_loading={isDeleting}
            onView={() => navigate(`/training/${data.id}`)}
            onEdit={() => navigate(`/training/edit/${data.id}`)}
            onDelete={() => delete_training(dispatch, data.id)}
          />
        );
      },
    },
  ];

  const currentPage = Math.floor(offset / limit) + 1;
  const lastPage = Math.max(1, Math.ceil(total / limit));

  return (
    <div>
      <div className="w-full flex justify-between items-center mb-6">
        <h2 className="font-bold text-xl capitalize mb-0">Training</h2>

        <Button
          type="button"
          title="Create"
          children={<FaPlus className="mr-2" />}
          onClick={() => navigate("/training/create")}
          className="px-4"
        />
      </div>

      <div>
        <DataTable
          columns={columns}
          data={trainings}
          current_page={currentPage}
          last_page={lastPage}
          onNext={(page) => get_trainings(dispatch, (page - 1) * limit, limit)}
          onPrev={(page) => get_trainings(dispatch, (page - 1) * limit, limit)}
        />
      </div>
    </div>
  );
};

export default Training;
